.gdpr-drawer {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;

  .gdpr-wrapper {
    background: #fff;
    border-top: 2px solid #d2cfff;
    padding: 20px 0;
    width: 100%;
  }

  &.gdpr-enabled {
    display: flex;
  }

  .gdpr-content {
    max-width: 1250px;
    margin: 0 auto;
    display: flex;

    p {
      margin-bottom: 15px;
      line-height: 20px;
      margin: 0;

      &:first-child {
        margin-bottom: 16px;
      }
    }

    ul {
      display: flex;
      list-style: none;
      align-items: center;
      padding: 0;

      li {
        margin-right: 20px;

        label {
          display: flex;
          align-items: center;
        }

        .label-switch {
          background-color: #cccccc;
          color: transparent;
          line-height: 0;
          width: 44px;
          height: 22px;
          display: block;
          border-radius: 10px;
          position: relative;
          transition-duration: 200ms;
          transition-property: background-color;
          transition-timing-function: ease-out;
          margin-right: 5px;

          &:after {
            content: '';
            background-color: grey;
            position: absolute;
            top: 0;
            left: 0;
            margin: 2px 2px;
            width: 18px;
            height: 18px;
            border-radius: 9px;
            transform: translateX(0);
            transition-duration: 300ms;
            transition-property: transform left margin;
            transition-timing-function: ease-out;
          }
        }

        &.active {
          .label-switch {
            background-color: #d2cfff;

            &:after {
              background-color: #0076c0;
              left: 100%;
              margin: 2px 2px 2px -2px;
              transform: translateX(-100%);
            }
          }
        }
      }
    }

    .gdpr-actions {
      display: flex;
      justify-content: center;
      margin-left: 20px;

      ul {
        li {
          margin: 0 0 0 20px;

          button {
            font-weight: 600;
            font-size: 18px;
            text-transform: none;
            background-color: #0076c0;
            color: #fff;
            display: inline-block;
            cursor: pointer;
            padding: 10px 20px;
            border: 0;
            min-width: 140px;
            min-height: 42px;

            &.save,
            &.customize {
              background: #fff;
              border: 1px solid #0076c0;
              color: #0076c0;
            }

            &:hover {
              background-color: #0076AC;
              color: #fff;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .gdpr-drawer {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 20;

    .gdpr-wrapper {
      background: #fff;
      border-top: 2px solid #d2cfff;
      padding: 20px 0;
    }

    .gdpr-box {
      p {
        display: none;
      }

      p:first-child {
        display: block;
        font-size: 16px;
        text-align: center;
        font-weight: 600;
        margin: 0;
      }
    }

    .gdpr-content {
      margin: 0 20px;
      display: block;
      width: auto;

      ul {
        display: block;

        li {
          margin: 0 0 20px;
        }
      }

      .gdpr-actions {
        margin-left: 0;

        ul {
          display: flex;

          li {
            margin: 0 10px;

            button {
              &:hover {
                background-color: #0076c0;
                color: #fff;
              }

              &.save,
              &.customize,
              &.customize:hover,
              &.save:hover {
                background: #fff;
                border: 1px solid #0076c0;
                color: #0076c0;
              }
            }
          }
        }
      }
    }
  }
}
